export default __webpack_public_path__ + "static/media/jira_icon.b8847c33.svg";